var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowHideCalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Light mode cal icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-mode-cal-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    fill: "#E7C6F6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5416667,15.7083333 L14.5,15.7083333 L14.5,21.75 L20.5416667,21.75 L20.5416667,15.7083333 L20.5416667,15.7083333 Z M19.3333333,2.41666667 L19.3333333,4.83333333 L9.66666667,4.83333333 L9.66666667,2.41666667 L7.25,2.41666667 L7.25,4.83333333 L6.04166667,4.83333333 C4.7125,4.83333333 3.625,5.92083333 3.625,7.25 L3.625,24.1666667 C3.625,25.4958333 4.7125,26.5833333 6.04166667,26.5833333 L22.9583333,26.5833333 C24.2875,26.5833333 25.375,25.4958333 25.375,24.1666667 L25.375,7.25 C25.375,5.92083333 24.2875,4.83333333 22.9583333,4.83333333 L21.75,4.83333333 L21.75,2.41666667 L19.3333333,2.41666667 L19.3333333,2.41666667 Z M22.9583333,24.1666667 L6.04166667,24.1666667 L6.04166667,10.875 L22.9583333,10.875 L22.9583333,24.1666667 L22.9583333,24.1666667 Z",
    id: "Event"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowHideCalIcon);
export default __webpack_public_path__ + "static/media/show-hide-cal-icon.d72eee4c4fdc55fefbec732349f3ba51.svg";
export { ForwardRef as ReactComponent };